import classNames from 'classnames';
import {CheckErrordSvg, CheckRightdSvg} from '../../Svg/index';
import style from './index.module.less';

export default function Check(props: any) {
  const {type, className} = props;
  if (!type) {
    return <input {...props} type="checkbox"/>;
  } else {
    return <div {...props} className={classNames(style.wrap, className)}>{type === 'success' ? CheckRightdSvg() : type === 'fail' ? CheckErrordSvg() : <div className={style[type]}></div>}</div>;
  }
}